import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

export const refreshWeather = async (): Promise<void> => {
  await axios.put(`/api/weather/`);
};

type QueryFnType = typeof refreshWeather;

type UseRefreshWeatherOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useRefreshWeather = ({ config }: UseRefreshWeatherOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['refreshWeather'],
    queryFn: () => refreshWeather(),
  });
};
